import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
export class ViewEditPropertyDetailsPvConstants {
    static SG_CODE_LABEL = "SG Code";
    static DESCRIPTION_LABEL = "Description";
    static ADDRESS_LABEL = "Address";
    static ERF_NUMBER_LABEL = "Erf no";
    static FARM_NUMBER_LABEL = "Farm no";
    static UNIT_NUMBER_LABEL = "Unit no";
    static ERF_SIZE_LABEL = "Erf size";
    static IMPROVEMENT_LABEL = "Improvement";
    static AREA_LABEL = "Allotment / suburb";
    static ZONING_LABEL = "Zone";
    static OWNERS_LABEL = "Owners";
    static OWNERS_LIST_LABEL = "Owner";
    static SG_CODE_CONTROL_NAME = "sgCodeEdit";
    static DESCRIPTION_CONTROL_NAME = "descriptionEdit";
    static ADDRESS_CONTROL_NAME = "addressEdit";
    static ERF_NUMBER_CONTROL_NAME = "erfNumberEdit";
    static FARM_NUMBER_CONTROL_NAME = "farmNumberEdit";
    static UNIT_NUMBER_CONTROL_NAME = "unitNumberEdit";
    static ERF_SIZE_CONTROL_NAME = "erfSizeEdit";
    static IMPROVEMENT_CONTROL_NAME = "improvementEdit";
    static IMPROVEMENT_CONTROL_LABEL = "improvement";
    static AREA_CONTROL_NAME = "allotmentEdit";
    static ZONING_CONTROL_NAME = "zoningEdit";
    static OWNER_CONTROL_NAME = "ownersEdit";
    static PLACEHOLDER_TEXT = "Please select an option";
    static SUBDIVISION_PORTION_NUMBER_LABEL = "Subdivision/Portion number";
    static SUBDIVISION_PORTION_NUMBER_CONTROL_NAME = "subdivisionEdit";
    static VALIDATION_MESSAGES = {
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfNumber: {
            required: `Erf number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNumber: {
            required: `Farm number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        portionNbr: {
            required: `Subdivision/Portion number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        improvement: {
            required: `Improvement ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        area: {
            required: `Area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zoning: {
            required: `Zoning ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
